var DTSService = (function () {
    function DTSService($localStorage, socket, env, $filter, $http, _) {
        this.$localStorage = $localStorage;
        this.socket = socket;
        this.env = env;
        this.$filter = $filter;
        this.$http = $http;
        this._ = _;
    }
    DTSService.prototype.now = function () {
        var x = new Date().toISOString();
        x = x.replace('T', ' ');
        x = x.replace('Z', ' ');
        return x;
    };
    DTSService.prototype.timestamp = function (x) {
        var t = new Date(x).toISOString();
        t = t.replace('T', ' ');
        t = t.replace('Z', '');
        return t;
    };
    DTSService.prototype.getIndex = function (array, id, tp) {
        var i = -1;
        _.some(array, function (data, idx) {
            if (data[tp] === id) {
                i = idx;
                return i;
            }
        });
        return i;
    };
    DTSService.prototype.getAvatar = function (user, size) {
        if (!user || user === undefined) {
            return null;
        }
        var baseUrl = 'https://w3-unifiedprofile-api.dal1a.cirrus.ibm.com';
        return baseUrl + "/v3/image/" + user + "?def=null&size=" + (size || 115);
    };
    DTSService.prototype.token = function () {
        return this.$localStorage.token;
    };
    DTSService.prototype.getDate = function (dt) {
        var dat = new Date(parseInt(dt));
        return dat;
    };
    DTSService.prototype.guid = function () {
        function _p8(s) {
            var array = new Uint32Array(2);
            var p = (window.crypto.getRandomValues(array)[0].toString(16) + '000000000').substr(2, 8);
            return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
        }
        var t = _p8(false) + _p8(true) + _p8(true) + _p8(false);
        return t.toLowerCase();
    };
    // Retrieves name & serial number from faces
    DTSService.prototype.getUser = function (email) {
        //return this.$http.jsonp('//faces.tap.ibm.com/api/find/?q=' + email +'&callback=JSON_CALLBACK');
        return this.$http.jsonp('https://w3-services1.w3-969.ibm.com/myw3/unified-profile/v1/api/find?q=' + email + '&callback=JSON_CALLBACK');
    };
    DTSService.$inject = [
        '$localStorage', 'socket', 'env', '$filter', '$http', '_'
    ];
    return DTSService;
}());
angular
    .module('application')
    .service('DTS', DTSService);

//# sourceMappingURL=DTS.js.map
